import { call, put, takeLatest } from "redux-saga/effects";
import { BannerEventFetchAction } from "./types";
import { BANNER_EVENT_FETCH } from "./constants";
import api from "../../../api-new/http";
import { bannerEventData, bannerEventError } from "./actions";
import { API, RequestOptions } from "../../../api";
import { appUrls } from "../../../api-new/urls";

const requestOptions: RequestOptions = {
    apiVersion: 'peatio',
};

export function* BannerEventSaga({payload: queryFilter}: BannerEventFetchAction) {
    try {
        const filteredQueryFilter = Object.fromEntries(
            Object.entries(queryFilter).filter(
            ([_, value]) => value !== null && value !== undefined && !(typeof value === "string" && value.trim().length === 0)
            )
        );
        const queryString = new URLSearchParams(filteredQueryFilter as Record<string, string>).toString();

        const response = yield call(() => api.get(`${appUrls.tradeURL}/banners?${queryString}`));
        yield put(bannerEventData(response.data));
    } catch (error) {
        yield put(bannerEventError(error));
    }
}

export function* rootBannerEventSaga(): Generator {
    yield takeLatest(BANNER_EVENT_FETCH, BannerEventSaga);
}
